<template>
  <div class="hello">
    <hd @updateMenu="getCurrentMenu" class="header"></hd>
    <div class="main-content">
      <div class="side-menu isMobile">
        <ul>
          <li :class="{ selected: currentMenu.label === menu.label }" v-for="menu in menus"><a style="position:relative;"
              :href="menu.url">{{ menu.label }}
            </a>
          </li>
        </ul>
      </div>
      <div class="content-container">        
          <router-view ref="routerView" />
      </div>
    </div>
    <!--<mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>-->
    <GlobalDialogs></GlobalDialogs>
    <MessageDialog></MessageDialog>
  </div>
</template>

<script>
import hd from './Header'
import ft from './Footer'
import mobilefooter from './mobilefooter'
import api from '../services/api.js'
import { POSTMENU } from '../services/constant.js'
import GlobalDialogs from './GlobalDialogs'
import MessageDialog from './MessageDialog'


export default {
  name: 'HelloWorld',
  components: {
    hd: hd,
    ft: ft,
    GlobalDialogs: GlobalDialogs,
    mobilefooter: mobilefooter,
    MessageDialog: MessageDialog
  },
  created() {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
      this.taskInfo.mobiletype = true
      this.$store.commit('updateTaskInfo', this.taskInfo)
    }
    this.getCurrentMenu()
  },
  computed: {
    taskInfo() {
      return this.$store.state.taskInfo
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      mobiletype: false,
      menus: POSTMENU,
      currentMenu: {},
      option:1,

    }
  },
  async mounted() {
    
  },
  methods: {
    getCurrentMenu() {
      let name = this.$route.name
      for (let menu of this.menus) {
        if (menu.url.indexOf(name) > -1) {
          this.currentMenu = menu
          return
        }
      }
    }
  },
  watch: {
    $route() {
      this.getCurrentMenu()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  border-bottom: 1px solid #d7d7d7;
}

.crumbs {
  margin-top: 34px;
  max-width: 1200px;
  margin: 34px auto 10px;
}

.main-content {
  padding-top: 144px;
  display:flex;
  .select-shop {
    max-width: 760px;
    margin: 0 auto;
  }

  .side-menu {
    padding-top: 80px;
    width: 243px;
    text-align: center;
    ul {
      .selected {
        font-weight: bold;
        color: #333;
      }

      a {
        color: #666;
        line-height: 35px;
      }
    }
  }

  .content-container {
    flex:1;
    border-left: 1px solid #D7D7D7;
    .title {
      height: 20px;
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      text-align: center;
      margin-bottom: 35px;
      font-weight: bold;
    }
  }
}

@media screen and (max-width:1024px) {

  .main-content {
    padding-top: 51px;

    .isMobile {
      display: none !important;
    }

    .content-container {
      margin-left: 0px;
      padding-right: 0px;
      padding-top: 20px;
      min-height: 56vh;

      &>div {
        padding: 0 10px;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/PostSideMenu.vue